import { render, staticRenderFns } from "./sildBarList.vue?vue&type=template&id=83342014&scoped=true&"
import script from "./sildBarList.vue?vue&type=script&lang=js&"
export * from "./sildBarList.vue?vue&type=script&lang=js&"
import style0 from "./sildBarList.vue?vue&type=style&index=0&id=83342014&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83342014",
  null
  
)

export default component.exports